import React from 'react';

export default function ServiceFeature() {
  const services = [
    {
      id: "engineering",

      title: "Engineering Support from Design to Production",
      description: "Our engineering expertise extends across every stage of the product lifecycle, from initial concept and design to production-ready solutions. Using advanced CAD platforms such as Zuken, Creo, and CATIA, we develop optimized wiring harness designs that improve performance, simplify manufacturing, and meet the highest standards of quality, reliability, and efficiency.Working closely with our customers, we transform design requirements into practical, manufacturable solutions through detailed engineering, routing optimization, and design validation. This collaborative approach helps reduce development time, minimize production challenges, and deliver products that are ready for seamless integration.",
      link: "#"
    },
    {
      id: "custom",
    
      title: "Custom Wiring Harnesses for Your Application",
      description: "Every application presents unique electrical and mechanical challenges. We design and manufacture custom wiring harnesses tailored to your exact specifications, ensuring seamless integration, long-term durability, and dependable performance. Whether for prototype development or high-volume production, our solutions are built to meet your operational requirements.From connector selection and cable routing to material compatibility and final assembly, every harness is developed with careful attention to detail. Our flexible manufacturing capabilities allow us to support projects of varying complexity while maintaining consistent quality and on-time delivery.",
      link: "#"
    },
    {
      id: "quality",
  
      title: "Reliable Manufacturing Quality at Every Stage",
      description: "Quality is at the core of everything we manufacture. From precision wire processing and assembly to rigorous inspection and testing, every wiring harness undergoes strict quality control before delivery. Our streamlined manufacturing processes and commitment to continuous improvement ensure consistent products that customers can trust for critical applications.Our production team follows standardized manufacturing practices supported by modern equipment and comprehensive inspection procedures. This focus on precision, traceability, and continuous quality assurance enables us to deliver dependable wiring harness solutions that consistently meet customer expectations and industry requirements.",
      link: "#"
    },
    {
      id: "industries",

      title: "Solutions for Automotive, Industrial & Energy",
      description: "We deliver reliable wiring harness and interconnect solutions for a wide range of industries, including automotive, commercial vehicles, industrial automation, renewable energy, and specialized equipment. Our engineering-driven approach enables us to address complex connectivity requirements while ensuring safety, efficiency, and long-term reliability in demanding environments.By understanding the unique demands of each industry, we develop solutions that withstand harsh operating conditions and support reliable system performance. Whether powering industrial machinery or enabling advanced mobility solutions, our products are engineered to perform with confidence.",
      link: "#"
    }
  ];

  return (
  <section className="bg-white py-12 sm:py-20 border-b border-gray-200">
  <div className="max-w-7xl mx-auto px-6 lg:px-12">
    
    {/* Improved Section Heading */}
    <div className="relative mb-12 sm:mb-10 max-w-2xl">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 tracking-tight sm:leading-tight">
      A Complete Harness Solution
      </h2>
    
    </div>

    {/* Row-Based Service List */}
    <div className="flex flex-col border-t border-gray-200">
      {services.map((service) => (
        <div 
          key={service.id} 
          id={service.id}
          className="scroll-mt-24 border-b border-gray-200 py-8 sm:py-12 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start px-2 sm:px-4 -mx-2 sm:-mx-4"
        >
          {/* Left Column: Title only */}
          <div className="md:col-span-4">
            <h4 className="text-xl font-bold text-slate-900 tracking-tight">
              {service.title}
            </h4>
          </div>
          
          {/* Right Column: Description */}
          <div className="md:col-span-8">
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              {service.description}
            </p>
          </div>
        </div>
      ))}
    </div>

    {/* Bottom Industry Recognition Banner */}
    <div className="mt-16 flex flex-col md:flex-row items-center gap-6 bg-gray-50 p-6 sm:p-10 border border-gray-100 rounded-sm">
      <div className="flex-shrink-0">
        <img 
          className="h-20 sm:h-24 w-auto object-contain" 
          alt="PEAK Matrix Leader 2024 recognition badge" 
          src="/logo.png"
        />
      </div>
      <div>
        <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2">
          Recognized as an Industry Leader in Digital & Infrastructure Architecture
        </h3>
        <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
          Our continuous commitment to client co-creation, rugged engineering standards, and innovative cross-domain execution models positions us at the absolute cutting edge of system manufacturing and design.
        </p>
      </div>
    </div>

  </div>
</section>
  );
}